import { RefObject, useEffect } from "react";

type ResizeObserverCallback = () => void;

export const useResizeObserver = <T extends Element>(
  ref: RefObject<T>,
  callback: ResizeObserverCallback
) => {
  useEffect(() => {
    let resizeObserver: ResizeObserver | null = null;

    const setupResizeObserver = async () => {
      if (!ref.current) {
        return;
      }

      if (!window.ResizeObserver) {
        const { default: ResizeObserverPolyfill } = await import(
          "resize-observer-polyfill"
        );

        window.ResizeObserver =
          ResizeObserverPolyfill as typeof window.ResizeObserver;
      }

      resizeObserver = new window.ResizeObserver(() => {
        requestAnimationFrame(() => {
          callback();
        });
      });

      resizeObserver.observe(ref.current);
    };

    setupResizeObserver();

    return () => {
      resizeObserver?.disconnect();
    };
  }, [ref, callback]);
};
